/*!
 * Animation
 */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".l-main h1").forEach((element) => {
    element.classList.add("is-fadein");
  });
});
